<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      
      <div class="d-flex align-items-center">
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une demande"
          />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nom
              </th>
             <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Prénom
              </th>
             <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Sexe
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Email
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Téléphone 1
              </th>
             <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date d'inscription
              </th>
               <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
               Statut
              </th>
             
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(demande, index) in demandes" :key="index">
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ demande.nom }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ demande.prenom }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ demande.sexe }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ demande.email }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ demande.telephone1 }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_Date(demande.createdAt) }}
              </td>
              <td class="shadow-none lh-1">
                <span :class="getStatutClass(demande.statut)" class="badge fw-medium">
                  {{ getStatutLabel(demande.statut) }}
                </span>
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
              >
               <div class="dropdown">
              <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu dropdown-block" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(267px, 305px);" data-popper-placement="bottom-start">
                   
                    <li class="dropdown-item d-flex align-items-center">
                        <router-link :to="{ name: 'ViewDemandeInscriptionPage', params: { id: demande.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                        </router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center" v-if="demande.statut === 0">
                      <router-link :to="{ name: 'TraiterDemandeInscriptionPage', params: { id: demande.id } }" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>Traiter
                      </router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center" >
                      <a
                        class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(demande.id,demandes,'demandes',`la demande de ${demande.nom} ${demande.prenom}`)">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1" ></i>
                         Supprimer
                      </a>
                    </li>
                  </ul>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
    </div>
 
</template>

<script lang="ts">
import { defineComponent, onMounted, ref} from "vue";
import Swal from "sweetalert2";
import { DemandeInscription } from "@/models/DemandeInscription";
import ApiService from "@/services/ApiService";
import { suppression, error, format_Date } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";

export default defineComponent({
  name: "ListeDemandeInscription",
  components: {
    PaginationComponent
  },
  setup(){
    
    onMounted(() => {
      getAllDemandeInscriptions();
    });

    const demandes = ref<Array<DemandeInscription>>([]);   
    const demande = ref<DemandeInscription>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllDemandeInscriptions(page_, limit_);
      } catch (error) {
        //
      }
    };

     function rechercher(){
      getAllDemandeInscriptions(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllDemandeInscriptions(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/demandes?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          demandes.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }
    

const getStatutLabel = (statut: number): string => {
      return statut === 1 ? 'Validé' : 'En cours';
    };

    const getStatutClass = (statut: number): string => {
      return statut === 1
        ? 'bg-success text-white'   // Validé → Vert
        : 'bg-warning text-dark';   // En cours → Jaune
    };

    function moddifier(Editdemandes:DemandeInscription) {
      demande.value = Editdemandes;
    }

    const deleteDemandeInscription = (id: number) => {
      ApiService.delete(`/demandes/${id}`)
      .then(({ data }) => {
        Swal.fire({
          text: data.message,
          toast: true,
          icon: 'success',
          title: 'General Title',
          animation: false,
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false
        });
      })
      .catch(({ response }) => {
        Swal.fire({
          text: response.data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Réssayer à nouveau!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      });

      for(let i = 0; i < demandes.value.length; i++) {
        if (demandes.value[i].id === id) {
          demandes.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return { demandes,
      checkPermission,
     getAllDemandeInscriptions,
     deleteDemandeInscription,
     moddifier ,
     suppression,
     page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    rechercher,format_Date,
    searchTerm, getStatutLabel,
      getStatutClass,
  };
  },
});
</script>